/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgRelationshipClickBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.10257 15.275L15.9016 6.61238M19.1739 22.5L18.059 18.3545M18.059 18.3545L16 20.1737L16.4664 12.4324L20.7553 18.9042L18.059 18.3545ZM21 4.48157C21 6.12825 19.6569 7.46315 18 7.46315C16.3431 7.46315 15 6.12825 15 4.48157C15 2.8349 16.3431 1.5 18 1.5C19.6569 1.5 21 2.8349 21 4.48157ZM9 17.4017C9 19.0484 7.65685 20.3833 6 20.3833C4.34315 20.3833 3 19.0484 3 17.4017C3 15.755 4.34315 14.4202 6 14.4202C7.65685 14.4202 9 15.755 9 17.4017Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const SvgRelationshipClick = wrapIcon(SvgRelationshipClickBase);
export default SvgRelationshipClick;
